import _ from 'lodash';
import Api from 'services/Api';

export const mutationTypes = {
    DOCUMENTS: 'DOCUMENTS',
    UPDATE_CATEGORY: 'UPDATE_CATEGORY',
    UPDATE_DOCUMENT_NAME: 'UPDATE_DOCUMENT_NAME',
    UPDATE_ORDER: 'UPDATE_ORDER',
    CATEGORY_LIST: 'CATEGORY_LIST',
    UPDATE_OGDEN_TABLES: 'UPDATE_OGDEN_TABLES',
    UPDATE_OGDEN_TABLE_DATA: 'UPDATE_OGDEN_TABLE_DATA',
    UPDATE_AT_A_GLANCE: 'UPDATE_AT_A_GLANCE',
};

const state = {
    documents: [],
    orderBy: 'ASC',
    documentName: null,
    categoryList: null,
    category: null,
    ogdenTables: [],
    ogdenTableData: {},
    atAGlance: {},
};

const getters = {
    getDocuments: () => state.documents,
    getResources: () => state,
    ogdenTables: () => state.ogdenTables,
    ogdenTableData: () => state.ogdenTableData,
    atAGlance: () => state.atAGlance,
};

const actions = {
    getDocumentsFromServer({ commit }) {
        return Api.resources.documents.all().then((data) => {
            commit(mutationTypes.DOCUMENTS, data.documents);
            commit(mutationTypes.CATEGORY_LIST, data.categories);
        });
    },
    setCategory({commit}, value) {
        commit(mutationTypes.UPDATE_CATEGORY, value);
    },
    setDocumentName({commit}, value) {
        commit(mutationTypes.UPDATE_DOCUMENT_NAME, value);
    },
    setOrderBy({commit}, value) {
        commit(mutationTypes.UPDATE_ORDER, value);
    },
    documentSearch({ commit, state }) {
        return Api.resources.documents.search(state.documentName, state.category, state.orderBy).then((data) => {
            return commit(mutationTypes.DOCUMENTS, data);
        })
    },
    loadOgdenTables({commit}) {
        return Api.resources.ogden.tableInfo().then(data => commit(mutationTypes.UPDATE_OGDEN_TABLES, data));
    },
    obtainOgdenTable({commit, state}, name) {
        if (state.ogdenTableData[name]) {
            return;
        }
        return Api.resources.ogden.obtainValues(name).then(data => commit(mutationTypes.UPDATE_OGDEN_TABLE_DATA, {
            data,
            name
        }));
    },
    atAGlance({commit, state}, {discount, gender}) {
        return Api.resources.ogden.atAGlance(discount, gender).then(data => commit(mutationTypes.UPDATE_AT_A_GLANCE, {
            data,
            discount,
            gender
        }));
    },
};

const mutations = {
    [mutationTypes.DOCUMENTS](state, data) {
        state.documents = data;
    },
    [mutationTypes.CATEGORY_LIST](state, data) {
        state.categoryList = data;
    },
    [mutationTypes.UPDATE_CATEGORY](state, data) {
        state.category = data;
    },
    [mutationTypes.UPDATE_DOCUMENT_NAME](state, data) {
        state.documentName = data;
    },
    [mutationTypes.UPDATE_ORDER](state, data) {
        state.orderBy = data;
    },
    [mutationTypes.UPDATE_OGDEN_TABLES](state, data) {
        state.ogdenTables = data;
    },
    [mutationTypes.UPDATE_OGDEN_TABLE_DATA](state, payload) {
        state.ogdenTableData[payload.name] = payload.data;
    },
    [mutationTypes.UPDATE_AT_A_GLANCE](state, payload) {
        state.atAGlance = payload;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
    modules: {},
};



// WEBPACK FOOTER //
// ./src/store/modules/resources/index.js